import Button from "atoms/buttons/button";
import Heading from "atoms/typography/heading";
import Paragraph from "atoms/typography/paragraph";
import { NotebookConstants } from "constants/notebook-constants";
import { siteMap } from "internal-sitemap";
import NotebookRecord from "models/view-models/notebook-record";
import React from "react";
import { Redirect, useHistory } from "react-router";
import useNotebooksAtom from "utilities/hooks/domain/notebooks/use-notebooks-atom";
import useNotebooksRedirects from "utilities/hooks/domain/notebooks/use-notebooks-redirects";
import { t } from "utilities/localization-utils";
import { RouteUtils } from "utilities/route-utils";
import { ToastManager } from "utilities/toast/toast-manager";
import useLoading from "utilities/hooks/use-loading";
import Loader from "atoms/loaders/loader";

const CSS_CLASS_NAME = "c-notebooks-page";

const NotebooksPage = () => {
    const {
        resultObject: notebooks,
        loaded: areNotebooksLoaded,
        createNotebook,
    } = useNotebooksAtom();

    const loading = useLoading(!areNotebooksLoaded);

    const { redirectToDefaultNotebookRoute } = useNotebooksRedirects();

    const { push } = useHistory();

    const getNotebookRoute = (notebookId: number) => {
        return RouteUtils.getUrl(siteMap.notebooks.notebook.detail, {
            notebookId: notebookId,
        });
    };

    const handleCreatePageClick = async () => {
        try {
            const defaultNotebook = await createNotebook(
                new NotebookRecord().with({ name: t("default-notebook-name") })
            );

            if (!defaultNotebook || !defaultNotebook.id) {
                throw new Error();
            }

            const routeToNewNotebook = getNotebookRoute(defaultNotebook.id);

            push(routeToNewNotebook);
        } catch (error) {
            ToastManager.error(
                t("errors-actionResource", {
                    action: t("creating"),
                    resource: t("notebook"),
                })
            );
        }
    };

    if (
        areNotebooksLoaded &&
        notebooks.filter(
            (notebook) => notebook.id !== NotebookConstants.SharedPageNotebookId
        ).length
    ) {
        return <Redirect to={redirectToDefaultNotebookRoute} />;
    }

    return loading ? (
        <Loader />
    ) : (
        <div className={CSS_CLASS_NAME}>
            <section className={`${CSS_CLASS_NAME}__banner`}>
                <Heading cssClassName={`${CSS_CLASS_NAME}__title`}>
                    {t("notebooks-page--header")}
                </Heading>
                <Paragraph cssClassName={`${CSS_CLASS_NAME}__text`}>
                    {t("notebooks-page--intro")}
                </Paragraph>
                <Paragraph cssClassName={`${CSS_CLASS_NAME}__text`}>
                    {t("notebooks-page--instructions")}
                </Paragraph>
                <Button
                    cssClassName={`${CSS_CLASS_NAME}__button`}
                    onClick={handleCreatePageClick}>
                    {t("notebooks-page--button-text")}
                </Button>
            </section>
        </div>
    );
};

export default NotebooksPage;
